import { render, staticRenderFns } from "./TourBasicInfo.vue?vue&type=template&id=a9c46eba&scoped=true"
import script from "./TourBasicInfo.vue?vue&type=script&lang=js"
export * from "./TourBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./TourBasicInfo.vue?vue&type=style&index=0&id=a9c46eba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c46eba",
  null
  
)

export default component.exports